import { useMemo } from "react";
import { catalogToYup, MaskedIdValidator } from "../utils/catalogToYup";
import { IFormSchemaSection } from "../types";

export const useDynamicYupSchema = (
  sections: IFormSchemaSection[] | undefined,
  metadata?: unknown,
  options?: {
    defaultCountry?: string;
    maskedIdValidator?: MaskedIdValidator;
  }
) => {
  const defaultCountry = options?.defaultCountry;
  const maskedIdValidator = options?.maskedIdValidator;
  return useMemo(() => {
    if (!sections) return undefined;
    return catalogToYup({
      sections,
      metadata,
      defaultCountry,
      maskedIdValidator
    });
  }, [sections, metadata, defaultCountry, maskedIdValidator]);
};
